var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveThinkingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16683 20.1666H12.8335M7.3335 13.7499H14.6668M4.5835 8.24992C4.5835 6.54811 5.25954 4.91601 6.4629 3.71265C7.66625 2.50929 9.29836 1.83325 11.0002 1.83325C12.702 1.83325 14.3341 2.50929 15.5374 3.71265C16.7408 4.91601 17.4168 6.54811 17.4168 8.24992C17.4176 9.2831 17.1678 10.3011 16.6888 11.2165C16.2099 12.132 15.516 12.9176 14.6668 13.5061L14.17 15.8583C14.1042 16.2918 13.8852 16.6874 13.5527 16.9733C13.2202 17.2592 12.7963 17.4165 12.3577 17.4166H9.64258C9.20406 17.4165 8.7801 17.2592 8.44761 16.9733C8.11511 16.6874 7.89611 16.2918 7.83033 15.8583L7.3335 13.5162C6.48401 12.9256 5.79016 12.1381 5.31126 11.221C4.83236 10.3039 4.58266 9.28452 4.5835 8.24992Z",
    stroke: "#2563EB",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveThinkingIcon);
export default __webpack_public_path__ + "static/media/active-thinking-icon.9bf3e363e83d47a06739266518f9ab15.svg";
export { ForwardRef as ReactComponent };